import type { SVGProps } from 'react';
const SvgTextRotationAngledown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#text_rotation_angledown_svg__a)">
      <path
        fill="currentColor"
        d="m19.4 4.91-1.06-1.06L7.2 8.27l1.48 1.48 2.19-.92 3.54 3.54-.92 2.19 1.48 1.48L19.4 4.91Zm-6.81 3.1 4.87-2.23-2.23 4.87-2.64-2.64ZM14.27 21v-4.24l-1.41 1.41-8.84-8.84-1.42 1.42 8.84 8.84L10.03 21h4.24Z"
      />
    </g>
    <defs>
      <clipPath id="text_rotation_angledown_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTextRotationAngledown;
